import { Instagram, ShoppingBag, MessageCircle } from "lucide-react";
import { LINKS, scrollToId } from "../data/site";

const NAV = [
  ["Início", "#inicio"],
  ["Produtos", "#produtos"],
  ["Sobre", "#sobre"],
  ["Contato", "#contato"],
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-ink pb-10 pt-12 text-white" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-8 px-5 sm:px-8 md:flex-row md:justify-between">
        <div className="flex items-center gap-3">
          <img src="images/logo-anime-glam.jpg" alt="Logo Anime Glam" className="h-12 w-12 rounded-full border-2 border-pinky object-cover" />
          <div>
            <p className="font-display text-lg font-bold">Anime Glam</p>
            <p className="font-hand text-xl text-white/60">by Camila Machado</p>
          </div>
        </div>

        <nav className="flex flex-wrap items-center justify-center gap-6 text-sm font-bold text-white/70">
          {NAV.map(([label, id]) => (
            <a key={id} href={id} onClick={scrollToId(id)} data-testid={`footer-link-${id.slice(1)}`} className="transition-colors hover:text-pinky">
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {[
            { href: LINKS.instagram, icon: Instagram, testid: "footer-instagram-link", label: "Instagram" },
            { href: LINKS.shopee, icon: ShoppingBag, testid: "footer-shopee-link", label: "Shopee" },
            { href: LINKS.whatsapp, icon: MessageCircle, testid: "footer-whatsapp-link", label: "WhatsApp" },
          ].map(({ href, icon: Icon, testid, label }) => (
            <a
              key={testid}
              href={href}
              target="_blank"
              rel="noreferrer"
              aria-label={label}
              data-testid={testid}
              className="grid h-11 w-11 place-items-center rounded-full border-2 border-white/15 text-white/80 transition-transform duration-300 hover:scale-110 hover:border-pinky hover:text-pinky"
            >
              <Icon size={18} />
            </a>
          ))}
        </div>
      </div>

      <p className="mt-10 text-center text-xs font-medium text-white/40">
        © {new Date().getFullYear()} Anime Glam · Feito com carinho em Bragança Paulista - SP
      </p>
    </footer>
  );
}
